import { useContext } from 'react'
import { Button, Alert } from 'react-bootstrap'
import { ProspectContext } from './../contexts/ProspectContext'
import { PaymentError as PaymentErrorClass } from '../utils/payment'
import errorImage from './../img/payment_error.svg'
import reloadImage from './../img/icon_reload.svg'

const PaymentError = ({ error }) => {
  const { state } = useContext(ProspectContext)

  const handleReload = () => {
    window.location.href = `/ui/prospect/${state.prospect.prospectId}/${state.selectedPlan.title}/subscribe`
  }

  const handleGoBack = () => {
    window.location.href = `/ui/prospect/${state.prospect.prospectId}`
  }

  // Determine error message based on error type
  let title = 'Er is iets fout gegaan'
  let message = 'Probeer het met een andere betaalmethode.'
  let showRetryButton = true
  let technicalDetails = null

  if (error instanceof PaymentErrorClass) {
    switch (error.type) {
      case 'DUPLICATE_PAYMENT':
        title = 'Betaling al verwerkt'
        message = 'Deze betaling is reeds verwerkt. Uw mandat is verzekerd.'
        showRetryButton = false
        if (error.details.caseId) {
          technicalDetails = `Case ID: ${error.details.caseId}`
        }
        break

      case 'STRIPE_ERROR':
        title = 'Betalingsfout'
        message = error.message || 'De betaling kon niet worden verwerkt. Controleer uw betalingsgegevens en probeer opnieuw.'
        break

      case 'API_ERROR':
        title = 'Systeemfout'
        message = 'Er is een probleem opgetreden bij het verwerken van uw betaling. Probeer het later opnieuw.'
        break

      default:
        // Use generic message
        break
    }
  } else if (error === true || typeof error === 'boolean') {
    // Legacy boolean error - use generic message
  } else if (typeof error === 'string') {
    message = error
  } else if (error?.message) {
    message = error.message
  }

  return (
    <div className='PaymentError text-center'>
      <img className='mb-4' src={errorImage} alt='Payment error' />
      <h1 className='mb-2'>{title}</h1>
      <p className='lead mb-4'>{message}</p>

      {technicalDetails && (
        <Alert variant='info' className='mb-4'>
          {technicalDetails}
        </Alert>
      )}

      <div className='d-flex justify-content-center gap-2'>
        {showRetryButton ? (
          <Button onClick={handleReload} className='mr-2'>
            <img src={reloadImage} alt='Reload page' style={{ marginRight: '.5rem' }} />
            Opnieuw
          </Button>
        ) : (
          <Button onClick={handleGoBack} variant='primary'>
            Terug naar overzicht
          </Button>
        )}
      </div>

      <p className='mt-4'>
        Bij aanhoudende problemen, contacteer <a href='mailto:spccb@vanbreda.be'>spccb@vanbreda.be</a> onder vermelding van uw naam, uw contactgegevens, de naam van het faillissement en bijbehorend regsolnummer.
      </p>
    </div>
  )
}

export default PaymentError
